export enum CanadaFOPHighInMetadata {
  None = 0,
  SaturatedFats = 1,
  Sugars = 2,
  Sodium = 4
}
